import classes from './Features.module.scss';
import Image from 'next/image';
import Markdown from 'markdown-to-jsx';
import BadgeList from '../../molecules/badgeList/BadgeList';

export default function FeaturesHome(props) {
    if (!props) return null;

    const {
        image,
        title,
        copy,
        special_features,
        card_theme,
        app_list,
        background_image,
        tags_title
    } = props[0];

    console.log('game');

    return (
        <div
            className={`${classes.pwaBlock} ${classes.oFeaturesSectionBlock} ${
                classes[`image-${card_theme.image_position}`]
            } ${classes[`theme-${card_theme.region_color}`]}`}
        >
            <div className={`${classes.oContainer} container`}>
                <div className={`${classes.oBlockWrapper} row`}>
                    <div className={`${classes.oImageBlock}`}>
                        <figure className={classes.mImage}>
                            <Image
                                src={image?.data?.attributes.url}
                                alt={image?.data?.attributes.title}
                                width={image?.data?.attributes.width}
                                height={image?.data?.attributes.height}
                                className={classes.aImage}
                                aria-hidden="true"
                                layout="responsive"
                            />
                        </figure>
                    </div>
                    <div className={`${classes.oTextBlock} fontRTL`}>
                        <h3 className={`${classes.aTitle} fnt30f`}>{title}</h3>
                        <Markdown
                            className={`${classes.aText} ${classes.aDescriptionText} fnt18l fnt-sb`}
                        >
                            {copy}
                        </Markdown>
                    </div>
                    <div className={`${classes.oFeaturesBlock}`}>
                        <div className={classes.mImageList}>
                            {app_list.map((item) => (
                                <div key={item.id} className={classes.oCard}>
                                    <figure className={classes.mImage}>
                                        <Image
                                            src={item?.image?.data?.attributes?.url}
                                            alt={item?.image?.data?.attributes?.title}
                                            width={item?.image?.data?.attributes?.width}
                                            height={item?.image?.data?.attributes?.height}
                                            className={classes.aImage}
                                            aria-hidden="true"
                                            layout="responsive"
                                        />
                                    </figure>
                                    <span className={classes.aText}>
                                        {item?.image?.data?.attributes?.alternativeText}
                                    </span>
                                </div>
                            ))}
                        </div>
                        <BadgeList title={tags_title} data={special_features} />
                    </div>
                </div>
            </div>
            <div
                className={`${classes.oBackgroundBlock} ${
                    classes[`theme-${card_theme.region_color}`]
                }`}
            >
                <Image
                    src={background_image?.data?.attributes.url}
                    alt={background_image?.data?.attributes.title}
                    width={background_image?.data?.attributes.width}
                    height={background_image?.data?.attributes.height}
                    className={classes.aImage}
                    aria-hidden="true"
                    layout="responsive"
                />
            </div>
        </div>
    );
}
